/** Consultation workflow group chrome — IIT Hyderabad navy / saffron / gold. */

export const WORKFLOW_GROUPS = [
  {
    id: 'patient',
    label: 'Patient Information',
    color: 'border-iith-navy',
    bg: 'bg-iith-mist',
    text: 'text-iith-navy',
    accent: 'bg-iith-navy',
    sections: ['general_info', 'chief_complaints', 'past_history', 'tumor_board'],
  },
  {
    id: 'assessment',
    label: 'Clinical Assessment',
    color: 'border-iith-saffron',
    bg: 'bg-[#FFF7F3]',
    text: 'text-iith-saffron',
    accent: 'bg-iith-saffron',
    sections: ['clinical_examination', 'provisional_diagnosis', 'final_diagnosis'],
  },
  {
    id: 'plan',
    label: 'Treatment Plan',
    color: 'border-iith-navyMid',
    bg: 'bg-iith-mist',
    text: 'text-iith-navyMid',
    accent: 'bg-iith-navyMid',
    sections: ['treatment_plan', 'prescription', 'investigations'],
  },
  {
    id: 'wrapup',
    label: 'Wrap-up',
    color: 'border-iith-gold',
    bg: 'bg-[#FBF7EE]',
    text: 'text-[#8A6F2E]',
    accent: 'bg-iith-gold',
    sections: ['admission_request', 'visit_notes', 'review_date', 'referral'],
  },
];
